@if (viewMode === 'SELECT') {
  <!-- <ng-container *ngIf="!multiSelector; else multiple"> -->
  <mat-form-field class="w-full" [ngClass]="classes" [subscriptSizing]="'dynamic'">
    @if (label) {
      <mat-label [ngClass]="labelClass ?? 'text-sm font-light'">{{
        label
      }}</mat-label>
    }
    <mat-select
      [multiple]="multiSelector"
      [placeholder]="placeholder"
      [formControl]="control"
      >
      @for (service of filteredNetworkServices(); track service) {
        <mat-option
          [value]="service.networkServiceId"
          >
          {{ service.displayName }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
}

@if (viewMode === 'LIST') {
  <mat-selection-list [formControl]="control" class="grid grid-cols-2">
    @for (service of filteredNetworkServices(); track service) {
      <mat-list-option
        [disabled]="control.disabled"
        class="text-md font-medium"
        checkboxPosition="before"
        [value]="service.networkServiceId"
        >
        {{ service.displayName }}
      </mat-list-option>
    }
  </mat-selection-list>
}
